import extend from '@/utils/vuex-extend';
import {table} from '@/vuex-extend';
import {wait} from '@/utils/wait';
import {
	fetchList,
	printOrderDelivery,
	getOrderSku,
	orderDictList,
	orderReceived,
	printMark, printPackageNumber
} from '@/api/sms/forwarding-order';
import {getAllAdminList, getAllDepotList} from '@/api/sms/arrival-order';
import moment from 'moment';
import getLodop from '@/utils/lodop';
import {Message} from 'element-ui';
import {listPlatform} from "@/api/oms/goods";
import {listShop} from "@/api/oms/shopee-order";
import service from "@/utils/request";

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {},
		multipleSelection: [],
		goodsList: [],
		drawerVisible: false,
		depotList: [],
		orderDictList: [],
		brandList: [],
		pmcList:[],
		platformTypeList: [],
		operatorList: [],
		shopList: []
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'sms.forwarding-order.list', async function () {
				const {searchForm} = state;
				await dispatch('getData', {
					caller: fetchList,
					options: {
						depotId: searchForm.depotId,
						orderSn: searchForm.orderSn,
						startDate: searchForm.time && moment(moment(searchForm.time[0]).format('YYYY-MM-DD')).valueOf() / 1000,
						endDate: searchForm.time && moment(moment(searchForm.time[1]).format('YYYY-MM-DD')).valueOf() / 1000,
						shippingStartDate: searchForm.shippingTime && moment(moment(searchForm.shippingTime[0]).format('YYYY-MM-DD')).valueOf() / 1000,
						shippingEndDate: searchForm.shippingTime && moment(moment(searchForm.shippingTime[1]).format('YYYY-MM-DD')).valueOf() / 1000,
						paymentStartDate: searchForm.paymentDate && moment(moment(searchForm.paymentDate[0]).format('YYYY-MM-DD')).valueOf() / 1000,
						paymentEndDate: searchForm.paymentDate && moment(moment(searchForm.paymentDate[1]).format('YYYY-MM-DD')).valueOf() / 1000,
						checkStatus: searchForm.checkStatus,
						platformType: searchForm.platformType,
						shopId: searchForm.shopId,
						platformOrderSn: searchForm.platformOrderSn,
						agencyName: searchForm.agencyName,
						salesmanName: searchForm.salesmanName,
						buyerName: searchForm.buyerName,
						brand: searchForm.brand,
						state: searchForm.state,
						phone: searchForm.phone,
						email: searchForm.email,
						zipcode: searchForm.zipcode,
						received: searchForm.received,
						warehouse: searchForm.warehouse,
						invoiceNumber: searchForm.invoiceNumber,
						pmc: searchForm.pmc,
						...payload
					}
				});
			})
		},
		async getOrderSku({state, dispatch, commit}, payload) {
			await wait(dispatch, 'sms.forwarding-order.sku', async function () {
				const response = await getOrderSku(payload);
				if (response.data && response.data.length > 0) {
					commit('save', {
						goodsList: response.data
					})
				} else {
					Message.error({
						message: '无此订单',
						onClose: () => {
							commit('closeDrawer')
						}
					})
				}
			})
		},
		async printOrderDelivery({state, dispatch}, payload) {

			const {ids, batch} = payload;

			await wait(dispatch, `sms.forwarding-order.print.${payload.batch ? 'batch' : ids[0]}`, async function () {
				const response = await printOrderDelivery({
					ids: ids.join(',')
				});
				const LODOP = getLodop();
				LODOP.PRINT_INIT("createOrder");
				LODOP.SET_PRINT_STYLEA(0, "HtmWaitMilSecs", 100);
				response.data.map((v) => {
					LODOP.ADD_PRINT_HTM("10%", "10%", "90%", "90%", v);
					LODOP.NewPageA();
				})
				LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Height");
				LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Width");
				// LODOP.PREVIEW();
				// 直接打印
				LODOP.PRINT();
			})
		},


		async printMark({state, dispatch}, payload) {
			const {orderIds} = payload;
			await wait(dispatch, `sms.forwarding-order.mark.batch`, async function () {
				const response = await printMark(orderIds.join(','));
				if (response.code !== 200) {
					Message.error("批量打印唛头错误，请联系管理员");
				} else {
					const LODOP = getLodop();
					LODOP.PRINT_INITA(0, 0, 300, 300, "");
					LODOP.SET_PRINT_PAGESIZE(0, 1000, 1000, "CreateCustomPage");
					response.data.map((v) => {
						LODOP.NewPage();
						LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE", 1);

						LODOP.ADD_PRINT_TEXT(39, 8, 281, 54, "Carton Mark");
						LODOP.SET_PRINT_STYLEA(0, "FontSize", 33);
						LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

						//Packages a Of b
						LODOP.ADD_PRINT_TEXT(133, 18, 114, 36, "Packages");
						LODOP.SET_PRINT_STYLEA(0, "FontSize", 16);
						LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
						LODOP.ADD_PRINT_TEXT(134, 147, 32, 32, v.current);
						LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
						LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
						LODOP.ADD_PRINT_TEXT(134, 183, 32, 32, "Of");
						LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
						LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
						LODOP.ADD_PRINT_TEXT(133, 221, 32, 32, v.total);
						LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
						LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

						LODOP.ADD_PRINT_TEXT(192, 17, 112, 35, "Order No.");
						LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
						LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

						LODOP.ADD_PRINT_TEXT(192, 128, 145, 35, v.platformOrderSn);
						LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
						LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

						LODOP.ADD_PRINT_TEXT(226, 16, 113, 36, "Vendor:");
						LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
						LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
						LODOP.ADD_PRINT_TEXT(226, 129, 125, 37, v.vendor);
						LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
						LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);

						LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Page");
					})

					let mode = window.lodopMode;
					console.log("开始调用LODOP打印，当前模式:mode" + mode);
					if (!mode) {
						console.log("PRINT模式");
						LODOP.PRINT()
						console.log("PRINT模式完成");
					} else if (mode === 1) {
						console.log("PREVIEW模式");
						//预览模式
						LODOP.PREVIEW()
						console.log("PREVIEW模式完成");
					} else if (mode === 2) {
						//设计模式
						console.log("PRINT_DESIGN模式");
						LODOP.PRINT_DESIGN()
						console.log("PRINT_DESIGN模式完成");
					}
				}
			})
		},

		//打印package number
		async printPackageNumber({state, dispatch}, payload) {
			const {orderIds} = payload;
			await wait(dispatch, `sms.forwarding-order.package.batch`, async function () {
				const response = await printPackageNumber(orderIds.join(','));
				if (response.code !== 200) {
					Message.error("批量打印PackageNumber错误，请联系管理员");
				} else {
					const LODOP = getLodop();
					LODOP.PRINT_INITA(0, 0, 300, 300, "");
					LODOP.SET_PRINT_PAGESIZE(0, 1000, 1000, "CreateCustomPage");

					// 构建表格HTML
					const generateTableHTML = (order) => {
						let html = `<table border='1' cellpadding='5' cellspacing='0' style='width:100%;border-collapse:collapse;'>
          <thead>
            <tr><th colspan='3'>Customer PO#: ${order.platformOrderSn}</th></tr>
            <tr>
              <th>skuValue</th><th>package#</th><th>Qty</th>
            </tr>
          </thead>
          <tbody>`;
						order.packageNumbers.forEach(pkg => {
							html += `<tr>
            <td>${pkg.skuValue}</td>
            <td>${pkg.packageNo}</td>
            <td>${pkg.count}</td>
          </tr>`;
						});
						html += `</tbody></table>`;
						return html;
					};

					// 添加每个订单的表格到打印内容
					response.data.forEach(order => {
						// console.log(generateTableHTML(order));
						LODOP.ADD_PRINT_HTM("10%", "10%", "90%", "90%", generateTableHTML(order));
						LODOP.NewPageA();
					});

					LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Height");
					LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Width");


					let mode = window.lodopMode;
					console.log("开始调用LODOP打印，当前模式:mode" + mode);
					if (!mode) {
						console.log("PRINT模式");
						LODOP.PRINT()
						console.log("PRINT模式完成");
					} else if (mode === 1) {
						console.log("PREVIEW模式");
						//预览模式
						LODOP.PREVIEW()
						console.log("PREVIEW模式完成");
					} else if (mode === 2) {
						//设计模式
						console.log("PRINT_DESIGN模式");
						LODOP.PRINT_DESIGN()
						console.log("PRINT_DESIGN模式完成");
					}
				}
			})
		},

		async getAllDepotList({state, dispatch, commit}, payload) {
			await wait(dispatch, 'sms.forwarding-order.all-depot', async function () {
				const response = await getAllDepotList();
				if (response.data) {
					commit('save', {
						depotList: response.data.list
					})
				}
			})
		},

		async getOrderDictList({state, dispatch, commit}, payload) {
			await wait(dispatch, 'sms.forwarding-order.order-dict-list', async function () {
				const response = await orderDictList();
				if (response.data) {
					commit('save', {
						orderDictList: response.data.shippingStatusOption,
						brandList: response.data.brand,
						pmcList : response.data.pmc,
					})
				}
			})
		},

		async getPlatformTypeList({state, dispatch, commit}, payload) {
			await wait(dispatch, 'sms.forwarding-order.platform-type-list', async function () {
				const response = await listPlatform();
				if (response.data) {
					commit('save', {
						platformTypeList: response.data
					})
				}
			})
		},

		async getShopList({state, dispatch, commit}, payload) {
			await wait(dispatch, 'sms.forwarding-order.shop-list', async function () {
				const response = await listShop();
				if (response.data) {
					commit('save', {
						shopList: response.data
					})
				}
			})
		},

		async getOperatorList({state, dispatch, commit}, payload) {
			await wait(dispatch, 'sms.th-forwarding-order.dict-list', async function () {
				const response = await getAllAdminList();
				if (response.data) {
					commit('save', {
						operatorList: response.data.adminList
					})
				}
			})
		},
	},
	mutations: {
		openDrawer(state) {
			Object.assign(state, {drawerVisible: true})
		},
		closeDrawer(state) {
			Object.assign(state, {drawerVisible: false})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/sms/forwarding-order/list.js